module.exports = __webpack_public_path__ + "img/greenCheck.f199d2d6.png";